import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Snippet from '../../components/Snippet';
import Collage from '../../components/fleet/Collage';
import FAQ from '../../components/fleet/Faq';
import FleetCalcPuff from '../../components/fleet/FleetCalcPuff';
import FleetHero from '../../components/fleet/FleetHero';
import NewsAgent from '../../components/fleet/NewsAgent';
import SBS from '../../components/fleet/SBS';
import Table from '../../components/fleet/Table';

import CompanyOffer from '../../components/fleet/CompanyOffer';
import {
  buyerNews,
  collage,
  collage2,
  companyNews,
  companyOffer,
  driverNews,
  faq,
  fleetPuff,
  hero,
  hero2,
  imageAndLink,
  news2,
  rentAndShareImageAndLink,
  table,
} from './fleet-copy';
import './fleet.css';

const FleetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 96px;
  margin-bottom: 96px;

  @media (max-width: 768px) {
    gap: 40px;
  }

  & > div.container {
    width: 100%;
    max-width: 940px !important;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 96px;

    @media (max-width: 940px) {
      gap: 40px;
      padding: 0 32px;
    }
    & > div.offset_text {
      max-width: 530px;
      margin-top: 96px;

      @media only screen and (min-width: 940px) {
        max-width: 100%;
        margin-bottom: 96px;
      }
    }
    & > p.legal-text {
      font-weight: 400;
      font-size: 9px;
      line-height: 18px;
      color: #5f5f5f;
    }
  }
`;

<script
  type="module"
  src="https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js"
></script>;

const FleetSite = () => {
  const [persona, setPersona] = useState<'driver' | 'company' | 'buyer'>(
    'driver',
  );

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src =
      'https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js';

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const personaNews =
    persona === 'driver'
      ? driverNews
      : persona === 'company'
        ? companyNews
        : buyerNews;

  return (
    <FleetContainer id="fleet">
      <FleetHero {...hero} />
      <CompanyOffer {...companyOffer} />
      <Collage {...collage} />
      <kia-prislista-business></kia-prislista-business>
      <div className="container">
        <SBS {...rentAndShareImageAndLink} />
      </div>
      <Collage {...collage2} />
      <div className="container">
        <SBS {...imageAndLink} />
        <FleetCalcPuff {...fleetPuff} />
        {/* <PersonaSelector persona={persona} setPersona={setPersona} /> */}
        {/* <NewsAgent {...personaNews} /> */}
        <Table {...table} />
      </div>
      <FleetHero {...hero2} />
      <div className="container">
        <NewsAgent {...news2} />
        <FAQ {...faq} />
      </div>
      <Snippet page="fleet" />
    </FleetContainer>
  );
};

export default FleetSite;
